import { render, staticRenderFns } from "./BayWindow.vue?vue&type=template&id=5cd1ad0b&scoped=true"
import script from "./BayWindow.vue?vue&type=script&lang=js"
export * from "./BayWindow.vue?vue&type=script&lang=js"
import style0 from "./BayWindow.vue?vue&type=style&index=0&id=5cd1ad0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1ad0b",
  null
  
)

export default component.exports